import { render, staticRenderFns } from "./CRMPreferential.vue?vue&type=template&id=450dd0aa&scoped=true&"
import script from "./CRMPreferential.vue?vue&type=script&lang=js&"
export * from "./CRMPreferential.vue?vue&type=script&lang=js&"
import style0 from "./CRMPreferential.vue?vue&type=style&index=0&id=450dd0aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450dd0aa",
  null
  
)

export default component.exports